import type { AfterContentInit, OnChanges, QueryList } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  ElementRef,
  HostBinding,
  input,
} from '@angular/core';
import { PalantirAvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'palantir-avatar-group',
  templateUrl: './avatar-group.component.html',
  styleUrls: ['./avatar-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class PalantirAvatarGroupComponent implements OnChanges, AfterContentInit {
  @ContentChildren(PalantirAvatarComponent, { read: ElementRef })
  public avatars?: QueryList<ElementRef>;

  public type = input<'first-on-top' | 'last-on-top'>('first-on-top');

  public hoverExpansion = input<boolean>(false);

  @HostBinding('class.hover-expansion-enabled')
  public get hoverExpansionEnabledClass(): boolean {
    return this.hoverExpansion();
  }

  public ngOnChanges() {
    this.applyZIndex();
  }

  public ngAfterContentInit() {
    this.applyZIndex();
  }

  private applyZIndex() {
    const totalOfAvatars = this.avatars?.length;
    if (!totalOfAvatars) {
      return;
    }

    if (this.avatars)
      for (const [index, avatar] of Array.from(this.avatars).entries()) {
        this.setAvatarZIndex(avatar, index, totalOfAvatars);
      }
  }

  private setAvatarZIndex(avatar: ElementRef, index: number, totalOfAvatars: number) {
    const zIndex = this.type() === 'last-on-top' ? index + 1 : totalOfAvatars - index;

    avatar.nativeElement.style.zIndex = zIndex;
  }
}
